export const BEAMER_BUTTON_ID = 'changelog-package-icon';
